import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={15} height={15} fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1L7.5 7.5m0 0L14 14M7.5 7.5L1 1m6.5 6.5L1 14" stroke="var(--color-black)" strokeWidth={2} strokeLinecap="round" /></svg>;
}
export default SvgComponent;